import cn from 'classnames'
import { memo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import { isHorizontalMenuItem } from '../../helpers/isHorizontalMenuItem'

import { IMenuProps } from './models'

import styles from './Menu.module.scss'

export const Menu = memo<IMenuProps>(({ validChildren, activeIndex, onMenuItemClick }) => {
  return (
    <div className={cn(styles.menu)}>
      {validChildren.map((child, index) => {
        if (isHorizontalMenuItem(child)) {
          return (
            <Button
              variant={'text'}
              key={index}
              active={index === activeIndex}
              className={cn(styles.menuItem)}
              onClick={() => onMenuItemClick(index)}
            >
              {typeof child.props.title !== 'string' ? (
                child.props.title
              ) : (
                <Translation text={child.props.title} span />
              )}
            </Button>
          )
        }

        return null
      })}
    </div>
  )
})
